import Image from 'next/image';
import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "Cardstyle__Container",
  componentId: "sc-e59gj5-0"
})(["", " transition:all .2s ease-out;&:hover{", " box-shadow:0px 0px 1px 0px rgba(0,0,0,0.30);transition:all 0.3s ease-in;}@media (max-width:", "){", " &:hover{", "}}"], {
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "borderColor": "transparent",
  "padding": "9px"
}, {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(235 235 235 / var(--tw-border-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "borderStyle": "none",
  "padding": "0px"
}, {
  "borderColor": "transparent",
  "--tw-shadow": "0 0 #0000",
  "--tw-shadow-colored": "0 0 #0000",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});
export const ThumbImage = styled(Image).withConfig({
  displayName: "Cardstyle__ThumbImage",
  componentId: "sc-e59gj5-1"
})(["", ""], {
  "aspectRatio": "16 / 9",
  "height": "100% !important",
  "width": "100% !important",
  "borderRadius": "0.5rem",
  "objectFit": "cover"
});
export const DateAndView = styled.div.withConfig({
  displayName: "Cardstyle__DateAndView",
  componentId: "sc-e59gj5-2"
})(["", " @media (max-width:", "){", "}.viewer{", " img{", "}}"], {
  "marginTop": "1rem",
  "display": "flex",
  "alignItems": "center",
  "gap": "0.75rem",
  "fontSize": "1rem",
  "lineHeight": "18px",
  "--tw-text-opacity": "1",
  "color": "rgb(167 167 167 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "0.5rem"
}, {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.25rem"
}, {
  "aspectRatio": "1 / 1",
  "width": "0.875rem"
});
export const Title = styled.div.withConfig({
  displayName: "Cardstyle__Title",
  componentId: "sc-e59gj5-3"
})(["", " @media (max-width:", "){", "}"], {
  "overflow": "hidden",
  "display": "-webkit-box",
  "WebkitBoxOrient": "vertical",
  "WebkitLineClamp": "1",
  "fontSize": "1.875rem",
  "lineHeight": "42px",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(43 43 43 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "1.5rem",
  "lineHeight": "2rem"
});
export const Description = styled.div.withConfig({
  displayName: "Cardstyle__Description",
  componentId: "sc-e59gj5-4"
})(["", ""], {
  "marginBottom": "0.5rem",
  "overflow": "hidden",
  "display": "-webkit-box",
  "WebkitBoxOrient": "vertical",
  "WebkitLineClamp": "2",
  "height": "3rem",
  "fontSize": "21px",
  "fontWeight": "300",
  "lineHeight": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
});
export const TipsAction = styled.div.withConfig({
  displayName: "Cardstyle__TipsAction",
  componentId: "sc-e59gj5-5"
})(["", " img{", "}"], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between"
}, {
  "cursor": "pointer"
});
export const ListTag = styled.div.withConfig({
  displayName: "Cardstyle__ListTag",
  componentId: "sc-e59gj5-6"
})(["", ""], {
  "display": "flex",
  "gap": "0.25rem"
});
export const HeartAction = styled.div.withConfig({
  displayName: "Cardstyle__HeartAction",
  componentId: "sc-e59gj5-7"
})(["", " span{", "}"], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.125rem"
}, {
  "fontSize": "1rem",
  "lineHeight": "18px",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(167 167 167 / var(--tw-text-opacity, 1))"
});